import { FEATURES } from '@constants/Text'

/**
 * Está o profissional na Lista de Espera (funcionalidade `Lista de Espera`)?
 *
 * Este é o predicado ÚNICO do projeto: o guard do router e o layout consomem
 * esta mesma função — duplicar a regra faria as duas divergirem na primeira
 * mudança (mesma lição de `@utils/escritorioFeeFixoMigracao.js`).
 *
 * Fail-closed: mapa de flags vazio ou ausente devolve `false`. Nunca `true`
 * por default.
 */
export const estaNaListaDeEspera = ({ user, access } = {}) => {
  const mapaDeFlags = access || {}
  return Boolean(mapaDeFlags[FEATURES.LISTA_ESPERA])
}
